import React from 'react';
import PropTypes from 'prop-types';

import { grey400 } from 'material-ui/styles/colors';

const defaultStyle = {
  display: 'block',
  width: 40,
  height: 40,
  backgroundColor: grey400,
  borderRadius: 20,
  textAlign: 'center',
  lineHeight: '40px',
  fontSize: 16,
  color: 'white',
};

const ConversationAvatar = ({ name, style, ...restProps }) => {
  const [first = '', last = ''] = name.split(' ');
  const value = `${first.charAt(0)}${last.charAt(0)}`;

  return (
    <span style={{ ...defaultStyle, ...style }} {...restProps}>
      {value}
    </span>
  );
};

ConversationAvatar.propTypes = {
  name: PropTypes.string.isRequired,
  style: PropTypes.shape({}),
};

export default ConversationAvatar;



// WEBPACK FOOTER //
// ./src/views/chat/components/ConversationAvatar.js